<template>
  <div class="register_page">
    <div class="content_box">
      <div class="register_form">
        <div class="title">用户注册</div>
        <div class="subtitle">请填写完整以下信息</div>
        <div class="form_box">
          <el-form ref="form" :model="registerForm" label-width="100px">
            <el-form-item label="公司名称">
              <el-input
                v-model="registerForm.companyName"
                placeholder="填写正确的公司名称"
                class="input_box"
                auto-complete="new-password"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系人">
              <el-input
                v-model="registerForm.companyContact"
                placeholder="填写正确的联系人"
                class="input_box"
                auto-complete="new-password"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号码">
              <el-input
                v-model="registerForm.phone"
                placeholder="填写正确的手机号码,可以用于登录"
                class="input_box"
                auto-complete="new-password"
              ></el-input>
            </el-form-item>
            <el-form-item label="电话号码">
              <el-input
                v-model="registerForm.telephone"
                placeholder="（选填）填写正确的联系人电话"
                class="input_box"
                auto-complete="new-password"
              ></el-input>
            </el-form-item>
            <el-form-item label="QQ">
              <el-input
                v-model="registerForm.qq"
                placeholder="（选填）填写正确的QQ号码"
                class="input_box"
                auto-complete="new-password"
              ></el-input>
            </el-form-item>
            <el-form-item label="Email">
              <el-input
                v-model="registerForm.email"
                placeholder="（选填）填写正确的Email"
                class="input_box"
                auto-complete="new-password"
              ></el-input>
            </el-form-item>
            <el-form-item label="地区">
              <el-cascader
                v-model="registerForm.addressArray"
                :options="address"
                :props="{ expandTrigger: 'hover' }"
                class="input_box"
                auto-complete="new-password"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="地址">
              <el-input
                v-model="registerForm.address"
                placeholder="填写正确的联系地址"
                class="input_box"
                auto-complete="new-password"
              ></el-input>
            </el-form-item>
            <el-form-item label="邀请码">
              <el-input
                v-model="registerForm.invitePhone"
                placeholder="（选填）输入邀请码"
                class="input_box"
                auto-complete="new-password"
              ></el-input>
            </el-form-item>
            <el-form-item label="登录密码">
              <el-input
                v-model="registerForm.password"
                placeholder="输入登录密码"
                type="password"
                class="input_box"
                auto-complete="new-password"
              ></el-input>
              <br />
              <span class="tips">
                (为了您的帐户安全, 请使用"字母+数字+特殊符号"的组合,
                并且长度在6-20之间.)
              </span>
            </el-form-item>
            <el-form-item label="确认密码">
              <el-input
                v-model="registerForm.passwordAgain"
                placeholder="确保密码输入正确"
                type="password"
                class="input_box"
                auto-complete="new-password"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <div class="action_box">
                <el-button type="info" @click="toCancel">取消</el-button>
                <el-button
                  type="primary"
                  style="background: #00a0e9; border-color: #00a0e9"
                  @click="toRegister"
                  >注册</el-button
                >
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="null"></div>
    </div>
    <Bottom></Bottom>
  </div>
</template>

<script>
import china from "../assets/json/pcas-code.json";
import { registerApi } from "../api/index";
export default {
  name: "register",
  data() {
    return {
      registerForm: {
        companyName: "",
        companyContact: "",
        phone: "",
        telephone: "",
        qq: "",
        email: "",
        addressArray: [],
        province: "",
        city: "",
        area: "",
        address: "",
        invitePhone: "",
        password: "",
        passwordAgain: "",
      },
      options: china,
      address: [],
      loading: false,
    };
  },
  created() {},
  activated() {
    this.cleanForm();
  },
  mounted() {
    const address = china.map((province) => {
      const citys = province.children.map((f) => {
        const district = f.children.map((item) => {
          return {
            name: item.name,
            code: item.code,
            value: item.name,
            label: item.name,
          };
        });
        return {
          name: f.name,
          code: f.code,
          children: district,
          value: f.name,
          label: f.name,
        };
      });
      return {
        name: province.name,
        code: province.code,
        value: province.name,
        label: province.name,
        children: citys,
      };
    });
    this.address = address;
  },
  methods: {
    toCancel() {
      this.$router.go(-1);
    },
    toRegister() {
      if (!this.registerForm.companyName) {
        this.$message.warning("请填写正确的公司名称");
        return;
      }
      if (!this.registerForm.companyContact) {
        this.$message.warning("填写正确的联系人");
        return;
      }
      if (!this.registerForm.phone) {
        this.$message.warning("请填写正确的手机号码");
        return;
      }
      // 验证手机号格式
      const phoneReg = /^1[3-9]\d{9}$/;
      if (!phoneReg.test(this.registerForm.phone)) {
        this.$message.warning("请填写正确的手机号码格式");
        return;
      }
      if (this.registerForm.addressArray.length !== 3) {
        this.$message.warning("请选择完整的省市区");
        return;
      }
      if (!this.registerForm.password) {
        this.$message.warning("请输入登录密码");
        return;
      }
      if (!this.registerForm.passwordAgain) {
        this.$message.warning("请再次输入登录密码");
        return;
      }
      if (this.registerForm.passwordAgain !== this.registerForm.password) {
        this.$message.warning("请确保两次密码输入正确");
        return;
      }
      if (this.loading) {
        return;
      }
      this.loading = true;
      registerApi({
        companyName: this.registerForm.companyName,
        companyContact: this.registerForm.companyContact,
        phone: this.registerForm.phone,
        telephone: this.registerForm.telephone,
        qq: this.registerForm.qq,
        email: this.registerForm.email,
        province: this.registerForm.addressArray[0],
        city: this.registerForm.addressArray[1],
        area: this.registerForm.addressArray[2],
        address: this.registerForm.address,
        invitePhone: this.registerForm.invitePhone,
        password: this.registerForm.password,
      })
        .then((res) => {
          if (res.resultStatus) {
            this.$message.success("注册成功");
            this.cleanForm();
            setTimeout(() => {
              this.$router.push({
                name: "Home",
              });
            }, 1000);
          } else {
            this.$message.warning(res.errorMessage);
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cleanForm() {
      this.registerForm = {
        companyName: "",
        companyContact: "",
        phone: "",
        telephone: "",
        qq: "",
        email: "",
        addressArray: [],
        province: "",
        city: "",
        area: "",
        address: "",
        invitePhone: "",
        password: "",
        passwordAgain: "",
      };
    },
  },
};
</script>

<style lang="less">
.register_page {
  width: 100%;
  height: 100%;
  background-image: url("../assets/img/login_bg.png");
  background-position: initial;
  background-size: cover;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 0.1rem;
    background-color: rgba(0, 0, 0, 0);
  }

  &::-webkit-scrollbar-thumb {
    background-color: #d4d4d4;
  }
  @media screen and (min-width: 480px) {
    .content_box {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .register_form {
        width: 600px;
        background: #fff;
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        padding: 32px 0 20px;
        border-radius: 10px;
        z-index: 1;
        .title {
          width: 100%;
          font-size: 21px;
          color: #333;
          font-weight: 700;
          text-align: center;
          letter-spacing: 1.2px;
          margin-bottom: 10px;
        }
        .subtitle {
          width: 502px;
          font-size: 14px;
          color: #999;
          margin-bottom: 40px;
          letter-spacing: 1.6px;
        }
        .input_box {
          width: 400px;
        }
        .action_box {
          display: flex;
          align-items: center;
          justify-content: flex-end;
        }
      }
      .null {
        width: 100%;
        height: 100px;
      }
      .tips {
        width: 420px;
        font-size: 12px;
        color: #aaa;
        margin-top: 2px;
      }
    }
  }
  @media only screen and (max-width: 480px) {
    .content_box {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .register_form {
        width: 100%;
        background: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        padding: 32px 0 20px;
        z-index: 1;
        .title {
          width: 100%;
          font-size: 21px;
          color: #333;
          font-weight: 700;
          text-align: center;
          letter-spacing: 1.2px;
          margin-bottom: 10px;
        }
        .subtitle {
          width: 302px;
          font-size: 14px;
          color: #999;
          margin-bottom: 40px;
          letter-spacing: 1.6px;
        }
        .input_box {
          width: 250px;
        }
        .action_box {
          display: flex;
          align-items: center;
          justify-content: flex-end;
        }
      }
      .null {
        display: none;
      }
      .tips {
        width: 200px !important;
        font-size: 12px;
        color: #aaa;
        margin-top: 2px;
        display: flex;
        line-height: 16px;
      }
    }
  }
}
</style>